// extracted by mini-css-extract-plugin
export default {"root":"trust-pilot-module--root--b0220","transparent":"trust-pilot-module--transparent--4eb02"};